export enum PortalNotificationState {
  Draft = 'Draft',
  Expired = 'Expired',
  Public = 'Public',
  Scheduled = 'Scheduled',
}
